/**
 * Variables d’environnement **publiques** du front (DECISIONS §3.2).
 *
 * Seules des variables `VITE_*` sont lisibles ici : Vite les inscrit en clair dans le bundle.
 * Aucun secret ne doit donc jamais porter ce préfixe (aucune clé d’API, aucun jeton).
 */
import { API_BASE_PATH, LOCALE_DEFAUT, LOCALES, type Locale } from '@elemora/shared/constants';

/** Vrai si la valeur est une locale livrée en v1 (DECISIONS §9.3). */
function estLocale(valeur: string | undefined): valeur is Locale {
  return valeur !== undefined && (LOCALES as readonly string[]).includes(valeur);
}

/**
 * Base des appels HTTP.
 *
 * Par défaut `/api/v1` (chemin relatif) : en développement, le proxy Vite relaie `/api` vers
 * `http://localhost:3000`, ce qui garde le cookie de refresh en first-party. Une URL absolue
 * reste possible en production si l’API est servie sur un autre domaine.
 */
function baseApi(): string {
  const configuree = import.meta.env.VITE_API_BASE_URL?.trim();
  const sansSlashFinal = configuree?.replace(/\/+$/, '');
  return sansSlashFinal !== undefined && sansSlashFinal.length > 0 ? sansSlashFinal : API_BASE_PATH;
}

export const env = Object.freeze({
  apiBaseUrl: baseApi(),
  localeDefaut: estLocale(import.meta.env.VITE_DEFAULT_LOCALE)
    ? import.meta.env.VITE_DEFAULT_LOCALE
    : LOCALE_DEFAUT,
});
